import {Button, TextField, Typography} from "@mui/material"
import {Box} from "@mui/system"
import {FC, useEffect, useState} from "react"
import {AgeGroup} from "../../../models/ClimbingEvent"

interface Props {
    group: AgeGroup,
    handleUpdateGroup: (group: AgeGroup) => void
}

export const EditAgeGroup: FC<Props> = ({ handleUpdateGroup, group }) => {
    const [newGroup, setNewGroup] = useState(group)
    const [error, setError] = useState("")
    useEffect(() => {
        if (newGroup.name.length === 0) {
            setError("Nazwa grupy nie może być pusta")
        } else if(!newGroup.startYear && !newGroup.endYear){
           setError("Grupa musi mieć przynajmniej jeden rok")
        } else if (newGroup.startYear && newGroup.endYear  && newGroup.startYear > newGroup.endYear) {
            setError("Rok końca nie może być wcześniejszy niż rok początku")
        } else {
            setError("")
        }
    }, [newGroup])
    return (
        <Box component="form" sx={{ display: "flex", alignItems: "center", flexDirection: "column", }}>
            <TextField label="Nazwa grupy" value={newGroup.name} onChange={(e) => setNewGroup({ ...newGroup, name: e.target.value })} />
            <TextField label="Rocznik początkowy" type="number" value={newGroup.startYear} onChange={(e) => setNewGroup({ ...newGroup, startYear: parseInt(e.target.value) })} />
            <TextField label="Rocznik końcowy" type="number" value={newGroup.endYear} onChange={(e) => setNewGroup({ ...newGroup, endYear: parseInt(e.target.value) })} />
            <Button disabled={error.length > 0} onClick={() => handleUpdateGroup(newGroup)}>Zapisz</Button>
            <Typography color="error" sx={{ display: "block", mt: 2 }}>{error || ""}</Typography>
        </Box>
    )
}